import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KilomtrageChartComponent } from './kilomtrage-chart.component';
import { ToastrModule } from 'ngx-toastr';
import { HighchartsChartModule } from 'highcharts-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  declarations: [
    KilomtrageChartComponent
  ],
  imports: [
    CommonModule,
    ToastrModule.forRoot(),
    HighchartsChartModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    FormsModule,
    NgxLoadingModule.forRoot({}),

  ],
  exports: [
    KilomtrageChartComponent
  ]
})
export class KilomtrageChartModule { }
